var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-area__form"},[_c('h3',{staticClass:"h3-title"},[_vm._v(_vm._s(_vm.mp.NAME))]),_vm._v(" "),_c('p',{staticClass:"auth-text",domProps:{"innerHTML":_vm._s(_vm.mp.PREVIEW_TEXT)}})])}
var staticRenderFns = []

export { render, staticRenderFns }